<mat-card class="price-public-degrssivity-slice">
  <mat-card-header style="width: 100%;">
    <mat-card-title>{{ 'repository.public-degressivity-slice' | translate }}</mat-card-title>
    <mat-card-subtitle style="width: 100%;">
      <div style="width: 100%;display: flex; justify-content: space-between;">
        <div>
        </div>
        <div>
          <mat-slide-toggle [(ngModel)]="displayIndexesPrice" labelPosition="before">
            <span>{{ 'label.indexPrice' | translate }}</span>
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.name' | translate }}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span> {{ element.name }}</span>
        </td>
      </ng-container>

      <!-- number Column -->
      <ng-container matColumnDef="number">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.number' | translate }}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span> {{ element.number }}</span>
        </td>
      </ng-container>

      <!-- price Column -->
      <ng-container matColumnDef="price">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.price' | translate }} (€/T)</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="!displayIndexesPrice"> {{ element.price | number :'0.6' :'fr'}}</span>
          <span *ngIf="displayIndexesPrice"> {{ element.indexPrice | number :'0.6' :'fr'}}</span>
        </td>
      </ng-container>

      <!-- indexPrice Column -->
      <!-- <ng-container matColumnDef="indexPrice">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.indexPrice' | translate }} (€/T)</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span> {{ element.indexPrice | number :'0.6' :'fr'}}</span>
        </td>
      </ng-container> -->

      <!-- percentage Column -->
      <ng-container matColumnDef="percentage">
        <th class="header" mat-header-cell *matHeaderCellDef>
          <div mat-sort-header>{{ 'label.percentage' | translate }}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span> {{ element.percentage }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
        (click)="selectItemClick(row)"></tr>

    </table>
  </mat-card-content>
  <mat-card-actions>

  </mat-card-actions>

</mat-card>